<template>
<v-card flat>
    <v-card-text v-bind:style="($vuetify.breakpoint.smAndUp)?'{height: 5000px}':'{}'">
        <v-subheader class="title">
            Filtrar por:
            <v-chip close small
                v-if="Object.values(filter).reduce((acc,curr)=>acc || curr !== '',false)" 
                @input="filter = {photo:'',active:'',stock:'',pending:'',highlight:''};refresh()"
            >
                limpar todos
            </v-chip>
        </v-subheader>
        <v-list three-line>
            <v-list-tile>
                <v-radio-group hide-details v-model="filter.photo"
                    class="mt-0" @change="refresh" label="Fotos:"
                >   
                    <v-radio
                        label="Com fotos"
                        :value="true"
                        :color="color"
                    ></v-radio>
                    <v-radio
                        label="Sem fotos"
                        :value="false"
                        :color="color"
                    ></v-radio>
                </v-radio-group>
            </v-list-tile>
            <v-list-tile>
                <v-radio-group hide-details v-model="filter.active"
                    class="mt-0" @change="refresh" label="Status:"
                >   
                    <v-radio
                        label="Ativos"
                        :value="true"
                        :color="color"
                    ></v-radio>
                    <v-radio
                        label="Inativos"
                        :value="false"
                        :color="color"
                    ></v-radio>
                </v-radio-group>
            </v-list-tile>
            <v-list-tile>
                <v-radio-group hide-details v-model="filter.stock"
                    class="mt-0" @change="refresh" label="Estoque:"
                >   
                    <v-radio
                        label="Com estoque"
                        :value="true"
                        :color="color"
                    ></v-radio>
                    <v-radio
                        label="Sem estoque"
                        :value="false"
                        :color="color"
                    ></v-radio>
                </v-radio-group>
            </v-list-tile>
            <v-list-tile>
                <v-radio-group hide-details v-model="filter.pending"
                    class="mt-0" @change="refresh" label="Pendentes:"
                >   
                    <v-radio
                        label="Pendentes"
                        :value="true"
                        :color="color"
                    ></v-radio>
                    <v-radio
                        label="Não pendentes"
                        :value="false"
                        :color="color"
                    ></v-radio>
                </v-radio-group>
            </v-list-tile>
            <v-list-tile>
                <v-radio-group hide-details v-model="filter.highlight"
                    class="mt-0" @change="refresh" label="Em destaque:"
                >   
                    <v-radio
                        label="Sim"
                        :value="true"
                        :color="color"
                    ></v-radio>
                    <v-radio
                        label="Não"
                        :value="false"
                        :color="color"
                    ></v-radio>
                </v-radio-group>
            </v-list-tile>
        </v-list>
        <v-radio-group hide-details v-model="subtype" v-if="subtypes.length > 0">
            <v-list dense>
                <v-subheader class="title">
                    {{ $t('productsList.subtypes') }}
                </v-subheader>
                <v-list-tile>
                    <v-radio
                        :label="$t('productsList.all')"
                        :value="''"
                        :color="color"
                    ></v-radio>
                </v-list-tile>
                <v-list-tile v-for="(category, index) in subtypes" :key="index">
                    <v-radio
                        :label="category.name"
                        :value="category.name"
                        :color="color"
                    ></v-radio>
                </v-list-tile>
            </v-list>
        </v-radio-group>
    </v-card-text>
    <v-card-actions>
        <v-btn color="secondary" light
            block @click="$emit('exit')"
        >
            Fechar
        </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    props:['color'],
    computed: {
        ...mapGetters([
            'subtypes'
        ]),
        subtype:{
            get(){
                return this.$store.state.subtype
            },
            set(value){
                this.$store.commit('SET_SUBTYPE', value)
                this.$store.dispatch('fetchProducts')
            }
        },
        filter:{
            get(){
                return this.$store.state.filter
            },
            set(value){
                this.$store.commit('SET_FILTER', value)
                this.$store.dispatch('fetchProducts')
            }
        },
    },
    methods:{
        refresh(){
            this.filter = Object.assign({},this.filter)
        }
    }
}
</script>

<style>

</style>
